import { useQuery } from '@tanstack/react-query';
import type { Series } from '@jwp/ott-common/types/series';
import ContentApiService from '@jwp/ott-common/src/services/ContentApiService';
import { getModule } from '@jwp/ott-common/src/modules/container';
import { useTranslation } from 'react-i18next';
import { useConfigStore } from '@jwp/ott-common/src/stores/ConfigStore';

export const useNextEpisode = ({ series, episodeId }: { series: Series | undefined; episodeId: string | undefined }) => {
  const contentApiService = getModule(ContentApiService);
  const config = useConfigStore.getState().config;

  // Determine currently selected language
  const { i18n } = useTranslation();
  const language = i18n.language;

  const { isLoading, data } = useQuery({
    queryKey: ['next-episode', series?.series_id, episodeId, language],
    queryFn: async () => {
      const item = await contentApiService.getEpisodes({
        seriesId: series?.series_id,
        pageLimit: 1,
        afterId: episodeId,
        language,
        config,
      });

      return item?.episodes?.[0];
    },
    enabled: !!(series?.series_id && episodeId),
  });

  return {
    isLoading,
    data,
  };
};
